// extracted by mini-css-extract-plugin
module.exports = {"priceToggle":"InquiryPricingDetails_priceToggle__lVxT8"};